import { VerticalLine } from "../NavBar";
import { FC } from "react";
import { useLocation } from "react-router-dom";

const Footer: FC = () => {
  const location = useLocation();

  return (
    <footer className=" py-4 w-full">
      <div className="container  flex flex-col md:flex-col justify-between items-center w-full">
        <hr className="text-light_gray w-full mb-10 mt-10" />
        <div className="y flex  items-center w-full text-center">
          <p className="md:text-sm text-xs   md:mr-10 text-left">
            Copyright © 2024 Maani App
          </p>

          <nav className=" flex text-xs md:text-sm">
            <VerticalLine />
            <a href="/" className="mx-1 md:mx-10 text-gray hover:text-blue ">
              Home
            </a>
            <VerticalLine />
            <a
              href="mailto:contact@mymaani.com?subject=Support Inquiry"
              className={`mx-1 md:mx-10 ${
                location.pathname.startsWith("/support")
                  ? "text-blue"
                  : "text-gray"
              }`}
            >
              Support
            </a>
            <VerticalLine />
            <a
              href="/privacy-policy"
              className="mx-1 md:mx-10 text-gray hover:text-blue"
            >
              Privacy Policy
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
